<template>
    <div>
        <template v-if="hasPermission"> 
            <vx-card noShadow noRound>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <vs-input
                            v-model="user.first_name"
                            label="First Name"
                            class="w-full"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.first_name">
                            {{ api_errors.first_name.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <vs-input
                            v-model="user.last_name"
                            label="Last Name"
                            class="w-full"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.last_name">
                            {{ api_errors.last_name.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <vs-input
                            v-model="user.email"
                            label="Email"
                            class="w-full"
                            type="Email"
                            :disabled="user.id"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.email">
                            {{ api_errors.email.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <vs-input
                            v-model="user.password"
                            label="Password"
                            class="w-full"
                            type="Password"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.password">
                            {{ api_errors.password.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <SelectForeign
                            :model.sync="user.role"
                            label="Role"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['role']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.role_list}?is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                            :disabled="!editPermission"
                        />  
                        <small class="block text-danger mt-1" v-if="api_errors.role">
                            {{ api_errors.role }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="mb-3">
                        <SelectForeign
                            :model.sync="user.organisations"
                            label="Organisation"
                            placeholder="Choose Organisation..."
                            :multiple="true"
                            :load_initial="true"
                            :label_keys="['name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisations}?is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="false"
                            :disabled="!editPermission"
                        />
                        
                        <small class="block text-danger mt-1" v-if="api_errors.organisation || api_errors.organisation_ids">
                            {{ api_errors.organisation || api_errors.organisation_ids }}
                        </small>
                    </vs-col>

                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                        <label class="vs-input--label block">Is Active</label>
                        <div class="flex mt-3 align-center">
                            <vs-radio v-model="user.is_active" vs-name="is_active" :disabled="!editPermission" :vs-value="true">Yes</vs-radio>
                            <vs-radio v-model="user.is_active" vs-name="is_active" :disabled="!editPermission" :vs-value="false" class="mx-3">No</vs-radio>
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.is_active">
                            {{ api_errors.is_active.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>

                <vs-row class="mt-base" v-if="editPermission">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>

import { Request } from '../../utils/requests';

export default {
    data() {
        return {
            user: {
                email: null,
                password: null,
                first_name: null,
                last_name: null,
                role: {},
                organisations: [],
                is_active: true
            },

            submit_disabled: false,
            api_errors: {},
            organisationList: [],
        }
    }, 
    computed: { 
        viewUser() {
            return this.hasAccess('read', 'user', 'all')
        },
        createUser() {
            return this.hasAccess('create', 'user', 'all')
        },
        editUser() {
            return this.hasAccess('edit', 'user', 'all')
        },
        hasPermission() {
            return (!this.user.id && this.createUser) || (this.user.id && this.editUser)  || (this.user.id && this.viewUser)
        },
        editPermission() {
            return (!this.user.id && this.createUser) || (this.user.id && this.editUser)
        }
    },
    watch: {
        "$route.params.user_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        },
        organisationList(newList) {
            this.setOrganisationObjects();
        },
        'user.organisations'(newVal, oldVal) {
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.user_id = this.$route.params.user_id
            if (this.user_id) this.load_data()
        },
        setOrganisationObjects() {
            if (
                this.user &&
                this.user.organisations &&
                Array.isArray(this.organisationList) &&
                this.organisationList.length > 0
            ) {
                if (Array.isArray(this.user.organisations) && this.user.organisations.length > 0) {
                    if (typeof this.user.organisations[0] === 'number') {
                        const mapped = this.user.organisations.map(orgId => {
                            const found = this.organisationList.find(org => org.id === orgId);
                            if (found) {
                                return found;
                            } else {
                                return {
                                    id: orgId,
                                    name: `Organisation ${orgId} (Not Found)`,
                                    is_active: false
                                };
                            }
                        });
                        
                        this.user.organisations = mapped;
                    }
                }
                else if (this.user.organisation) {
                    if (typeof this.user.organisation === 'number') {
                        const orgObj = this.organisationList.find(org => org.id === this.user.organisation);
                        if (orgObj) {
                            this.user.organisations = [orgObj];
                        }
                    } else if (this.user.organisation && this.user.organisation.id) {
                        this.user.organisations = [this.user.organisation];
                    }
                }
            }
        },
        getData() {
            this.$vs.loading()
            let method = 'GET',
                url = this.$store.state.apiendpoints.organisations;
            Request(this, method, url, {limit: 1000}).then(res => {
                const results = res['results'];
                this.organisationList = results;
                this.$vs.loading.close()
                this.setOrganisationObjects();
            }).catch(err => {
                this.$vs.loading.close()
            });
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.organisation_user + this.user_id + "/"

            this.$vs.loading()

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.user = res
                    
                    if (res.organisations && Array.isArray(res.organisations)) {
                        this.user.organisations = res.organisations;
                    }
                    else if (res.organisation) {
                        this.user.organisations = [];
                    }
                    this.getData()
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.organisation_user
            if (this.user_id) {
                request_method = 'PUT'
                url += this.user_id + '/'
            }

            let payload = {
                ...this.user
            }
            
            if (payload.organisations && Array.isArray(payload.organisations)) {
                payload.organisation_ids = payload.organisations.map(org => {
                    return typeof org === 'object' && org.id ? org.id : org;
                }).filter(id => id != null);
                delete payload.organisations;
            }
            if (payload.organisation) {
                delete payload.organisation;
            }
            
            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.user = res

                    this.submit_disabled = false

                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'users-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        }
    }
}
</script>
